<template>
  <v-container
    :align-center="isLoading"
    :align-start="!isLoading"
    :fill-height="isLoading"
    fluid
    class="pa-0 justify-center"
  >
    <v-fade-transition>
      <v-progress-circular v-if="isLoading" size="48" width="3" indeterminate color="primary" />
      <slot v-else class="align-self-start" />
    </v-fade-transition>
  </v-container>
</template>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped></style>
